import {loginUser} from '../api/user';

const initialState = {
  token: '',
  errorLogin: null,
  menuDesplegado: false,
};

const LOGIN = 'LOGIN';
const ERRORLOGIN = 'ERRORLOGIN';
const MENUDESPLEGADO = 'MENUDESPLEGADO';

const setearLogin = (token) => ({type: LOGIN, payload: token});
const setearErrorLogin = (error) => ({type: ERRORLOGIN, payload: error});
const mostrarOcultarMenu = (mostrarOcultar) => ({
  type: MENUDESPLEGADO,
  payload: mostrarOcultar,
});

export const fetchLoginUser = (user, pass, brandId) => {
  return async (dispatch) => {
    const res = await loginUser(user, pass, brandId);
    if (res !== 'error') {
      return dispatch(setearLogin(res.data));
    } else {
      dispatch(setearErrorLogin(res));
    }
  };
};

export const setToken = (token) => {
  return (dispatch) => {
    return dispatch(setearLogin(token));
  };
};

export const setMostrarOcultarMenu = (mostrarOcultar) => {
  return (dispatch) => {
    return dispatch(mostrarOcultarMenu(mostrarOcultar));
  };
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    //en todos los casos regresamos un objeto nuevo en el cual incluimos todos las propiedades del objeto state con ...state
    case LOGIN:
      return {...state, token: action.payload};
    case ERRORLOGIN:
      return {...state, errorLogin: action.payload};
    case MENUDESPLEGADO:
      return {...state, menuDesplegado: action.payload};
    default:
      return {...state};
  }
};

export default userReducer;
